import { addMonths, differenceInMonths, endOfMonth, startOfMonth, subMonths, subYears } from 'date-fns';
import type { DateRange } from '../../types';
import type {
  MonthlyComparisonPresetId,
  MonthlyPresetId,
  MainPresetDefinition,
  ComparisonPresetDefinition,
} from '../types';

export const MONTHLY_PRESET_REGISTRY: Record<MonthlyPresetId, MainPresetDefinition<MonthlyPresetId>> = {
  custom: {
    id: 'custom',
    labelKey: 'datepicker.options.main.custom',
    calculate: () => undefined,
  },
  last_month: {
    id: 'last_month',
    labelKey: 'datepicker.options.main.last.month',
    calculate: () => ({
      from: startOfMonth(subMonths(new Date(), 1)),
      to: endOfMonth(subMonths(new Date(), 1)),
    }),
  },
  last_3_months: {
    id: 'last_3_months',
    labelKey: 'datepicker.options.main.last.three.months',
    calculate: () => ({
      from: startOfMonth(subMonths(new Date(), 3)),
      to: endOfMonth(subMonths(new Date(), 1)),
    }),
  },
  last_6_months: {
    id: 'last_6_months',
    labelKey: 'datepicker.options.main.last.six.months',
    calculate: () => ({
      from: startOfMonth(subMonths(new Date(), 6)),
      to: endOfMonth(subMonths(new Date(), 1)),
    }),
  },
  last_12_months: {
    id: 'last_12_months',
    labelKey: 'datepicker.options.main.last.twelve.months',
    calculate: () => ({
      from: startOfMonth(subYears(new Date(), 1)),
      to: endOfMonth(subMonths(new Date(), 1)),
    }),
  },
};

export const MONTHLY_COMPARISON_REGISTRY: Record<
  MonthlyComparisonPresetId,
  ComparisonPresetDefinition<MonthlyComparisonPresetId>
> = {
  custom: {
    id: 'custom',
    labelKey: 'datepicker.options.main.custom',
    calculate: () => undefined,
  },
  previous_period: {
    id: 'previous_period',
    labelKey: 'datepicker.options.comparison.previous.period',
    calculate: (_today, mainRange: DateRange) => {
      if (!mainRange.from || !mainRange.to) return undefined;
      const monthDiff = differenceInMonths(new Date(mainRange.to), new Date(mainRange.from)) + 1;
      return {
        from: startOfMonth(subMonths(new Date(mainRange.from), monthDiff)),
        to: endOfMonth(subMonths(new Date(mainRange.from), 1)),
      };
    },
  },
  previous_year: {
    id: 'previous_year',
    labelKey: 'datepicker.options.comparison.previous.year',
    calculate: (_today, mainRange: DateRange) => {
      if (!mainRange.from || !mainRange.to) return undefined;
      const monthDiff = differenceInMonths(new Date(mainRange.to), new Date(mainRange.from));
      const fromLastYear = startOfMonth(subMonths(new Date(mainRange.from), 12));
      return {
        from: fromLastYear,
        to: endOfMonth(addMonths(fromLastYear, monthDiff)),
      };
    },
  },
};
